const STORAGE_KEY = "lawlow.mailAttribution";
const INTERNAL_TEST_KEY = "lawlow.internalMailTest";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const MAIL_SOURCE = "lawlow_mail_auto";

export const isInternalMailTest = () => {
  if (new URLSearchParams(window.location.search).get("internal_test") === "1") {
    sessionStorage.setItem(INTERNAL_TEST_KEY, "1");
  }
  return sessionStorage.getItem(INTERNAL_TEST_KEY) === "1";
};

export const getMailExampleQuery = (search) => {
  const params = new URLSearchParams(search);
  if (params.get("utm_source") !== MAIL_SOURCE) return "";
  return (params.get("example_query") || "").trim().slice(0, 500);
};

export const getLandingExampleQuery = (search) => {
  const params = new URLSearchParams(search);
  if (![MAIL_SOURCE, "naver_blog", "tistory_blog"].includes(params.get("utm_source"))) return "";
  return (params.get("example_query") || "").trim().slice(0, 500);
};

export const getMailAttribution = () => {
  try {
    if (isInternalMailTest()) return null;
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (!saved || Date.now() - saved.capturedAt > MAX_AGE_MS) return null;
    return saved;
  } catch (_) {
    return null;
  }
};

export const captureMailAttribution = () => {
  try {
    if (isInternalMailTest()) return;
    const params = new URLSearchParams(window.location.search);
    const mailRef = params.get("mail_ref") || "";
    if (params.get("utm_source") !== MAIL_SOURCE || !/^[A-Za-z0-9_-]{8,128}$/.test(mailRef)) return;
    if (getMailAttribution()?.mail_ref === mailRef) return;
    const attribution = {
      mail_ref: mailRef,
      capturedAt: Date.now(),
      landing_path: window.location.pathname,
    };
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((key) => {
      attribution[key] = (params.get(key) || "").slice(0, key === "utm_source" || key === "utm_medium" ? 100 : 200);
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch (_) {
    // Tracking must not prevent editing or submitting a question.
  }
};

export const getMailPaymentAttribution = () => {
  const attribution = getMailAttribution();
  if (!attribution) return {};
  const { capturedAt, mail_ref, ...params } = attribution;
  return { ...params, attribution_id: mail_ref };
};

export const trackMailEvent = (event, { id, value } = {}) => {
  try {
    const attribution = getMailAttribution();
    if (!attribution || typeof window.gtag !== "function") return false;
    if (!["engaged_visit", "first_search", "signup", "purchase"].includes(event)) return false;
    if (event === "purchase" && (!id || !Number.isFinite(Number(value)))) return false;
    const key = `lawlow.mailEvent:${attribution.mail_ref}:${event}:${event === "purchase" ? id : ""}`;
    if (localStorage.getItem(key)) return false;
    window.gtag("event", `mail_${event}`, {
      send_to: "G-2KK5WXSX39",
      mail_ref: attribution.mail_ref,
      campaign: attribution.utm_campaign,
      source: attribution.utm_source,
      medium: attribution.utm_medium,
      campaign_content: attribution.utm_content,
      campaign_term: attribution.utm_term,
      landing_path: attribution.landing_path,
      ...(event === "purchase" ? { transaction_id: String(id), value: Number(value), currency: "KRW" } : {}),
    });
    localStorage.setItem(key, String(Date.now()));
    return true;
  } catch (_) {
    return false;
  }
};

export const observeMailVisit = () => {
  captureMailAttribution();
  const onInteraction = (event) => {
    if (event.isTrusted && document.visibilityState === "visible") {
      trackMailEvent("engaged_visit");
    }
  };
  window.addEventListener("pointerdown", onInteraction);
  window.addEventListener("keydown", onInteraction);
  return () => {
    window.removeEventListener("pointerdown", onInteraction);
    window.removeEventListener("keydown", onInteraction);
  };
};
